import { useClient, useItems } from "@adamlip/okeoke.client"
import CategoryCard from "components/HomeScreenCategories/CategoryCard"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext, useEffect, useState } from "react"
import { isDesktop } from "react-device-detect"

export default function Categories({ element }) {
  const { appParams } = useContext(AppParamsContext)
  const { getName } = useClient()
  const { categoryTree, categories } = useItems()
  const [filteredCategories, setFilteredCategories] = useState([])
  const [classes, setClasses] = useState("")

  useEffect(() => {
    let filtered = []
    if (element?.attributes?.categoriesToShow === "onlySub") {
      categoryTree?.forEach((category) => {
        category?.categories?.forEach((subCategory) => {
          if (
            categories[subCategory?.uuid]?.enabled &&
            (subCategory.availability?.availableItems > 0 ||
              subCategory.availability?.availableSubItems > 0) &&
            (subCategory.availability?.visibleItems > 0 ||
              subCategory.availability?.visibleSubItems > 0)
          ) {
            filtered.push(subCategory)
          }
        })
      })
    } else if (
      element?.attributes?.categoriesToShow === "onlyMain" ||
      element?.attributes?.categoriesToShow == null
    ) {
      categoryTree?.forEach((category) => {
        if (
          categories[category?.uuid]?.enabled &&
          (category.availability?.availableItems > 0 ||
            category.availability?.availableSubItems > 0) &&
          (category.availability?.visibleItems > 0 ||
            category.availability?.visibleSubItems > 0)
        ) {
          filtered.push(category)
        }
      })
    } else if (element?.attributes?.categoriesToShow === "both") {
      categoryTree?.forEach((category) => {
        if (
          categories[category?.uuid]?.enabled &&
          (category.availability?.availableItems > 0 ||
            category.availability?.availableSubItems > 0) &&
          (category.availability?.visibleItems > 0 ||
            category.availability?.visibleSubItems > 0)
        ) {
          filtered.push(category)
        }
        category?.categories?.forEach((subCategory) => {
          if (
            categories[subCategory?.uuid]?.enabled &&
            (subCategory.availability?.availableItems > 0 ||
              subCategory.availability?.availableSubItems > 0) &&
            (subCategory.availability?.visibleItems > 0 ||
              subCategory.availability?.visibleSubItems > 0)
          ) {
            filtered.push(subCategory)
          }
        })
      })
    }
    setFilteredCategories(filtered)
    //eslint-disable-next-line
  }, [categoryTree, categories, appParams])

  useEffect(() => {
    let classStr = ""
    if (isDesktop) {
      classStr +=
        "flex flex-row flex-wrap gap-2 max-w-[700px] mx-auto justify-center"
    } else {
      if (element?.attributes?.categoriesLayout === "list") {
        classStr += "w-full flex flex-row gap-2 overflow-x-scroll pb-4"
      } else {
        classStr += "flex flex-wrap gap-4 justify-center"
      }
    }
    setClasses(classStr)
  }, [element])

  if (filteredCategories.length < 1) return null
  return (
    <div className="px-3">
      {getName(element?.attributes?.label) && (
        <p className="text-lg font-bold mb-2">
          {getName(element?.attributes?.label)}
        </p>
      )}

      <div className={classes}>
        {filteredCategories?.map((category) => {
          return (
            <CategoryCard
              key={category.uuid}
              showImage={element?.attributes?.showCategoriesImage}
              category={category}
              categories={categories}
              layout={element?.attributes?.categoriesLayout}
            />
          )
        })}
      </div>
    </div>
  )
}